var _circle, _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSellTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6668,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4239 14.8662H22.2495V11.0583C22.2489 10.3358 21.9636 9.64306 21.4564 9.1322C20.949 8.62133 20.2611 8.33401 19.5438 8.33331H19.1114C18.727 8.33331 18.3583 8.48708 18.0865 8.76084C17.8147 9.03476 17.6618 9.40596 17.6618 9.79325V12.6812C17.6308 13.9695 17.1619 15.208 16.3333 16.1898L15.3816 16.9392H15.3814C15.3558 16.7647 15.2682 16.6055 15.1351 16.4909C15.0018 16.3766 14.8319 16.3144 14.6568 16.3163H9.72608C9.53381 16.3163 9.34946 16.3934 9.21364 16.5301C9.07765 16.6671 9.00131 16.8528 9.00131 17.0463V27.6033C9.00131 27.797 9.07765 27.9827 9.21364 28.1195C9.34945 28.2564 9.53381 28.3333 9.72608 28.3333H14.6685C14.8607 28.3333 15.0451 28.2564 15.1809 28.1195C15.3169 27.9827 15.3932 27.797 15.3932 27.6033V27.0681H25.781C26.4471 27.0703 27.0922 26.8338 27.6011 26.401C28.1099 25.9682 28.4495 25.3673 28.559 24.7056L29.6197 18.6011C29.6982 18.163 29.6808 17.7129 29.5689 17.2823C29.3792 16.5885 28.9689 15.9765 28.4007 15.5401C27.8326 15.1038 27.138 14.867 26.4235 14.8662L26.4239 14.8662ZM13.9439 26.8736H10.4508V17.7738H13.9439V26.8736ZM28.1969 18.3577L27.1292 24.46C27.077 24.782 26.9127 25.0746 26.6656 25.2854C26.4186 25.4963 26.105 25.6117 25.7813 25.6109H15.3935V18.7982L17.2899 17.3043C17.3306 17.2726 17.3678 17.2368 17.401 17.1972C18.4754 15.9436 19.0812 14.3515 19.1137 12.696V9.79341H19.5463C19.8792 9.79392 20.1982 9.92749 20.4338 10.1646C20.6692 10.4017 20.8017 10.7231 20.8023 11.0585V15.5962C20.8023 15.7899 20.8787 15.9756 21.0147 16.1124C21.1506 16.2493 21.3348 16.3262 21.5271 16.3262H26.4238C26.8204 16.3267 27.206 16.4579 27.5213 16.7001C27.8367 16.9423 28.0647 17.2817 28.1704 17.6668C28.2256 17.8915 28.2322 18.1256 28.1897 18.353L28.1969 18.3577Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellTicket);
export default __webpack_public_path__ + "static/media/sell-ticket.6960c9b44c93e84782cb0c82163f3f30.svg";
export { ForwardRef as ReactComponent };